export default [
  {
    path: '/ai_workforce',
    name: 'AiWorkforceHome',
    component: () => import('../views/ai_workforce/AiWorkforceHome.vue'),
    meta: {
      public: false,
      onlyLoggedOut: false
    },
  },
  {
    path: '/ai_workforce/:appId/rate-card/chat/',
    name: 'rate-card',
    component: () => import('../views/ai_workforce/chat/ChatView.vue'),
    meta: {
      public: false,
      onlyLoggedOut: false
    },
  },
  {
    path: '/ai_workforce/:appId/storyboard/:contentAppId',
    name: 'storyboard',
    component: () => import('../views/ai_workforce/storyboard/SessionListView.vue'),
    meta: {
      public: false,
      onlyLoggedOut: false
    },
  },
  {
    path: '/ai_workforce/:appId/storyboard/:contentAppId/form',
    name: 'storyboard-form',
    component: () => import('../views/ai_workforce/storyboard/StoryboardFormView.vue'),
    meta: {
      public: false,
      onlyLoggedOut: false
    },
  },
]
